define((require) => {
    "use strict";

    var Backbone     = require("backbone"),
        FontLoader   = require("shared/util/FontLoader"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        SceneViewer  = require("shared/ui/viewer/SceneViewer"),
        Rectangle    = require("shared/util/Rectangle"),
        template     = require("ui/viewer/SceneThumbnailViewer.tpl");

    /**
     * View model for the scene thumbnail.
     *
     * @class SceneThumbnailViewModel
     * @constructor
     */
    var SceneThumbnailViewModel = Backbone.Model.extend({
        defaults: {
            experience: null,
            viewportVisibility: new Rectangle(0, 0, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY)
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class SceneThumbnailViewer
     * @constructor
     *
     * @cfg {Scene} model The scene to display in the thumbnail.
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",

        template: template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner"
        },

        _experience: null,

        /**
         * @type {SceneViewer}
         */
        _overlayViewer: null,

        /**
         * @type {SceneViewer}
         */
        _sceneViewer: null,

        /**
         * @type {SceneViewer}
         */
        _backgroundViewer: null,

        initialize: function() {
            this._experience = this.options.experience;
        },

        onRender: function() {
            FontLoader.loadSceneFonts(this.model, this._experience)
                .always(() => {
                    if (this.isClosed) {
                        return;
                    }

                    var viewModel = new SceneThumbnailViewModel({experience: this._experience});

                    this._sceneViewer = new SceneViewer({
                        model:            this.model,
                        viewModel:        viewModel,
                        enableAnimations: false,
                        maxDimensions:    this.options.maxDimensions
                    });

                    var size = this._sceneViewer.getSize();

                    this.ui.sceneWrapper.width(size.scaledWidth);
                    this.ui.sceneWrapper.height(size.scaledHeight);
                    this.ui.sceneWrapper.append(this._sceneViewer.render().el);
                    this._sceneViewer.trigger("show");

                    if (this.options.showStaticScenes) {
                        this._overlayViewer = new SceneViewer({
                            model: this._experience.get("overlayScene"),
                            viewModel: viewModel,
                            maxDimensions: this.options.maxDimensions
                        });

                        this.ui.sceneWrapper.append(this._overlayViewer.render().el);
                        this._overlayViewer.trigger("show");

                        this._backgroundViewer = new SceneViewer({
                            model: this._experience.get("backgroundScene"),
                            viewModel: viewModel,
                            maxDimensions: this.options.maxDimensions
                        });

                        this.ui.sceneWrapper.prepend(this._backgroundViewer.render().el);
                        this._backgroundViewer.trigger("show");
                    }
                });
        },

        onClose: function() {
            // Make sure to properly close the viewer instances - they were appended
            // to the DOM outside of the normal (Marionette) lifecycle.
            if (this._overlayViewer) {
                this._overlayViewer.close();
            }

            if (this._sceneViewer) {
                this._sceneViewer.close();
            }

            if (this._backgroundViewer) {
                this._backgroundViewer.close();
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/SceneThumbnailViewer.js